import React from "react";
import { useTranslation } from "react-i18next";

interface BetaBadgeProps {
  className?: string;
  /** Size variant. `xs` is the default header/button companion size. */
  size?: "xs" | "sm";
}

/**
 * Shared "Beta" pill used to mark the CRM Chat surface during preview.
 *
 * Visual: amber/indigo gradient with subtle border so it reads next to a
 * primary label without competing with it.
 */
const BetaBadge: React.FC<BetaBadgeProps> = ({ className = "", size = "xs" }) => {
  const { t } = useTranslation();
  const sizeCn =
    size === "sm" ? "px-1.5 py-0.5 text-[10px]" : "px-1 py-[1px] text-[9px]";
  return (
    <span
      className={`inline-flex items-center rounded-full border border-indigo-200 bg-indigo-50 font-semibold uppercase tracking-wider text-indigo-700 ${sizeCn} ${className}`}
      aria-label={t("Beta feature") as string}
      title={t("Beta feature — your feedback is welcome") as string}
    >
      {t("Beta")}
    </span>
  );
};

export default BetaBadge;
